/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs */

const en_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller map`)
};

const ar_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خريطة البائع`)
};

const bn_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিক্রেতা মানচিত্র`)
};

const de_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Händlerkarte`)
};

const es_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa del vendedor`)
};

const fr_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte du vendeur`)
};

const pt_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa do vendedor`)
};

const zh_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家地图`)
};

const tr_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı haritası`)
};

const ru_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта продавца`)
};

const pl_svc_ecommerce_amazon_tools_scope_output5 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa sprzedawcy`)
};

/**
* | output |
* | --- |
* | "Seller map" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_scope_output5 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_scope_output5(inputs)
	return en_svc_ecommerce_amazon_tools_scope_output5(inputs)
});
export { svc_ecommerce_amazon_tools_scope_output5 as "svc_ecommerce-amazon-tools_SCOPE_output" }